import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export type ZendeskArticle = {
  id: number;
  title: string;
  htmlUrl: string;
  labelNames: string[];
  sectionName: string;
  snippet: string;
  createdAt: string;
  updatedAt: string;
};

function fetchZendeskArticles(labelNames?: string) {
  return axios.get('/api/zendesk/articles', {
    params: labelNames ? { labels: labelNames } : undefined
  });
}

function useZendeskArticles(labelNames?: string) {
  return useQuery({
    queryKey: ['zendesk-articles', labelNames],
    queryFn: () => fetchZendeskArticles(labelNames),
    select: (data: { data: ZendeskArticle[] }) => data.data,
    staleTime: Infinity
  });
}

export default useZendeskArticles;
